import React from "react";
import { createContext, useState } from "react";

const SopotakContext = createContext({
  tripType: "RETURN",
  from: "",
  to: "",
  fromDate: new Date().setHours(12, 0, 0, 0),
  toDate: new Date().setHours(12, 0, 0, 0),
  duration: 60,
  persons: 1,
  children: 0,
  bikes: 0,
  departureOffer: null,
  returnOffer: null,
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  countryCode: "",
  companyName: "",
  nip: "",
  city: "",
  postalCode: "",
  streetAddress: "",
  apartmentNumber: "",
  comments: "",
  recommendation: "",
  offersData: null,
  bookingData: null,
  invoice: false,
  marketingInfoApproved: false,
  setTripType: (tripType) => {},
  setFromDestination: (fromDestination) => {},
  setToDestination: (toDestination) => {},
  setFromDate: (fromDate) => {},
  setToDate: (toDate) => {},
  setDuration: (duration) => {},
  setPersons: (persons) => {},
  setChildren: (children) => {},
  setBikes: (bikes) => {},
  setDepartureOffer: (departureOffer) => {},
  setReturnOffer: (returnOffer) => {},
  setFirstName: (firstName) => {},
  setLastName: (lastName) => {},
  setEmail: (email) => {},
  setPhoneNumber: (phoneNumber) => {},
  setCountryCode: (countryCode) => {},
  setCompanyName: (companyName) => {},
  setNip: (nip) => {},
  setCity: (city) => {},
  setPostalCode: (postalCode) => {},
  setStreetAddress: (streetAddress) => {},
  setApartmentNumber: (apartmentNumber) => {},
  setComments: (comments) => {},
  setRecommendation: (recommendation) => {},
  setOffersData: (offersData) => {},
  setBookingData: (bookingData) => {},
  setInvoice: (invoiceRequested) => {},
  setMarketingInfoApproved: (marketingInfoApproved) => {},
});

export function SopotakContextProvider(props) {
  const [tripType, setTripType] = useState("TIME_BASED");

  const [fromDestination, setFromDestination] = useState("");
  const [toDestination, setToDestination] = useState("");
  const [fromDate, setFromDate] = useState(new Date(new Date().setHours(12, 0, 0, 0)));
  const [toDate, setToDate] = useState(new Date(new Date().setHours(12, 0, 0, 0)));
  const [duration, setDuration] = useState(60);

  const [persons, setPersons] = useState(1);
  const [children, setChildren] = useState(0);
  const [bikes, setBikes] = useState(0);

  const [departureOffer, setDepartureOffer] = useState(null);
  const [returnOffer, setReturnOffer] = useState(null);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [nip, setNip] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [apartmentNumber, setApartmentNumber] = useState("");
  const [comments, setComments] = useState("");
  const [recommendation, setRecommendation] = useState("");
  const [invoiceRequested, setInvoice] = useState(false);
  const [marketingInfoApproved, setMarketingInfoApproved] = useState(false);


  const [offersData, setOffersData] = useState([]);
  const [bookingData, setBookingData] = useState([]);



  function tripTypeChangeHandler(tripType) {
    setTripType(tripType);
  }
  function fromDestinationChangeHandler(fromDestination) {
    setFromDestination(fromDestination);
  }
  function toDestinationChangeHandler(toDestination) {
    setToDestination(toDestination);
  }
  function fromDateChangeHandler(fromDate) {
    setFromDate(fromDate);
  }
  function toDateChangeHandler(toDate) {
    setToDate(toDate);
  }
  function durationChangeHandler(duration) {
    setDuration(duration);
  }
  function personsChangeHandler(persons){
    setPersons(persons);
  }
  function childrenChangeHandler(children) {
    setChildren(children);
  }
  function bikesChangeHandler(bikes) {
    setBikes(bikes);
  }
  function departureOfferHandler(departureOffer) {
    setDepartureOffer(departureOffer);
  }
  function returnOfferHandler(returnOffer) {
    setReturnOffer(returnOffer);
  }
  function firstNameHandler(firstName) {
    setFirstName(firstName);
  }
  function lastNameHandler(lastName){
    setLastName(lastName);
  }
  function emailHandler(email){
    setEmail(email);
  }
  function phoneNumberHandler(phoneNumber){
    setPhoneNumber(phoneNumber);
  }
  function countryCodeHandler(countryCode){
    setCountryCode(countryCode);
  }
  function companyNameHandler(companyName){
    setCompanyName(companyName);
  }
  function nipHandler(nip){
    setNip(nip);
  }
  function cityHandler(city){
    setCity(city);
  }
  function postalCodeHandler(postalCode){
    setPostalCode(postalCode);
  }
  function streetAddressHandler(streetAddress) {
    setStreetAddress(streetAddress);
  }
  function apartmentNumberHandler(apartmentNumber){
    setApartmentNumber(apartmentNumber);
  }
  function commentHandler(comments){
    setComments(comments);
  }
  function recommendationHandler(recommendation){
    setRecommendation(recommendation);
  }
  function invoiceHandler(invoiceRequested){
    setInvoice(invoiceRequested);
  }

  function marketingInfoApprovedHandler(marketingInfoApproved){
    setMarketingInfoApproved(marketingInfoApproved);
  }

  function dataHandler(offerData){
    setOffersData(offerData);
  }

  function bookingDataHandler(bookingData){
    setBookingData(bookingData);
  }

  const context = {
    tripType: tripType,
    from: fromDestination,
    to: toDestination,
    fromDate: fromDate,
    toDate: toDate,
    duration: duration,
    persons: persons,
    children: children,
    bikes: bikes,
    departureOffer: departureOffer,
    returnOffer: returnOffer,
    firstName: firstName,
    lastName: lastName,
    email: email,
    phoneNumber: phoneNumber,
    countryCode: countryCode,
    companyName: companyName,
    nip: nip,
    city: city,
    postalCode: postalCode,
    streetAddress: streetAddress,
    apartmentNumber: apartmentNumber,
    comments: comments,
    recommendation: recommendation,
    invoiceRequested: invoiceRequested,
    marketingInfoApproved: marketingInfoApproved,
    offersData: offersData,
    bookingData: bookingData,
    setTripType: tripTypeChangeHandler,
    setFromDestination: fromDestinationChangeHandler,
    setToDestination: toDestinationChangeHandler,
    setFromDate: fromDateChangeHandler,
    setToDate: toDateChangeHandler,
    setDuration: durationChangeHandler, 
    setPersons: personsChangeHandler,
    setChildren: childrenChangeHandler,
    setBikes: bikesChangeHandler,
    setDepartureOffer: departureOfferHandler,
    setReturnOffer:returnOfferHandler,
    setFirstName:firstNameHandler,
    setLastName:lastNameHandler,
    setEmail:emailHandler,
    setPhoneNumber:phoneNumberHandler,
    setCountryCode:countryCodeHandler,
    setCompanyName:companyNameHandler,
    setNip:nipHandler,
    setCity:cityHandler,
    setPostalCode:postalCodeHandler,
    setStreetAddress:streetAddressHandler,
    setApartmentNumber:apartmentNumberHandler,
    setComments: commentHandler,
    setRecommendation:recommendationHandler,
    setOffersData:dataHandler,
    setBookingData:bookingDataHandler,
    setInvoice:invoiceHandler,
    setMarketingInfoApproved:marketingInfoApprovedHandler,
  };

  return (
    <SopotakContext.Provider value={context}>
      {props.children}
    </SopotakContext.Provider>
  );
}

export default SopotakContext;
